import { render } from "./BackgroundPosition.vue?vue&type=template&id=835a28f8&scoped=true&ts=true"
import script from "./BackgroundPosition.vue?vue&type=script&lang=ts"
export * from "./BackgroundPosition.vue?vue&type=script&lang=ts"

import "./BackgroundPosition.vue?vue&type=style&index=0&id=835a28f8&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835a28f8"]])

export default __exports__